<template>
<div class="">
    <div class="weui-cell" :class="{ 'weui-cell_warn': !valid }">
      <div class="weui-cell__hd">
        <label
          class="weui-label"
          v-html="label"
          v-if="label"
          :style="{ width: labelWidth + 'px' }"
        />
      </div>
      <div class="weui-cell__bd">
        <input
          class="weui-input"
          ref="input"
          :type="type"
          :auto-complete="autoComplete"
          :autofocus="autofocus"
          :placeholder="placeholder"
          :value="currentValue"
          :readonly="readonly"
          :disabled="disabled"
          :number="type === 'number'"
          :maxlength="maxlength"
          :minlength="minlength"
          @focus="onFocus"
          @blur="onBlur"
          @change="onChange"
          @input="handleInput">
      </div>
      <div class="weui-cell__ft">
        <wv-icon type="warn" v-if="!valid&&validateinfo.errormsg==''"/>
        <slot name="ft"/>
      </div>
    </div>
      <div class="weui-cells__tips" style="color:#e64340;text-align:left;" v-if="!valid&&validateinfo.errormsg!=''">
       <wv-icon type="warn" v-if="!valid"/>
      <slot name="ft"/>
      {{validateinfo.errormsg}}
    </div>
</div>

</template>

<script>
import Vue from "vue";

export default {
  name: "wviinput",
  props: {
    type: {
      type: String,
      default: "text"
    },
    label: String,
    labelWidth: {
      type: Number,
      default: 105
    },
    placeholder: String,
    value: String,
    name: String,
    autoComplete: {
      type: String,
      default: "off"
    },
    maxlength: Number,
    minlength: Number,
    autofocus: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    validateInfo: {
      type: Object,
      default: () => {
        return {
          errormsg: ""
        };
      }
    },
    pattern: String,
    validateMode: {
      type: Object,
      default: () => {
        return {
          onFocus: true,
          onBlur: true,
          onChange: true,
          onInput: true
        };
      }
    }
  },

  data() {
    return {
      active: false,
      valid: true,
      currentValue: this.value,
      validateinfo: this.validateInfo
    };
  },

  methods: {
    handleInput(event) {
      // 当有最大长度属性时，限制过长的输入
      if (this.maxlength && event.target.value.length >= this.maxlength) {
        this.currentValue = "";
        this.currentValue = event.target.value.substr(0, this.maxlength);
      } else {
        this.currentValue = event.target.value;
      }

      if (
        typeof this.validateMode === "undefined" ||
        this.validateMode.onInput !== false
      ) {
        this.validate();
      }
    },

    focus() {
      this.$refs.input.focus();
    },

    onFocus() {
      this.active = true;
      this.$emit("focus", this.$data);

      if (
        typeof this.validateMode === "undefined" ||
        this.validateMode.onFocus !== false
      ) {
        this.validate();
      }
    },

    onBlur() {
      this.active = false;
      this.$emit("blur", this.$data);

      if (
        typeof this.validateMode === "undefined" ||
        this.validateMode.onBlur !== false
      ) {
        this.validate();
      }
    },

    onChange() {
      this.$emit("change", this.$data);

      if (
        typeof this.validateMode === "undefined" ||
        this.validateMode.onChange !== false
      ) {
        this.validate();
      }
    },

    validate() {
      if (this.pattern) {
        const reg = new RegExp(this.pattern);
        if (
          !reg.test(this.currentValue) &&
          this.currentValue != "" &&
          typeof this.currentValue != "undefined"
        ) {
          this.valid = false;
          return;
        }
      }

      if (
        this.required &&
        (this.currentValue === "" || typeof this.currentValue == "undefined")
      ) {
        this.valid = false;
        return;
      }

      if (this.minlength && this.currentValue.length < this.minlength) {
        this.valid = false;
        return;
      }

      this.valid = true;
    }
  },

  watch: {
    currentValue(val) {
      this.$emit("input", val);
    },

    value(val) {
      this.currentValue = val;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/packages/input/index.vue